import React, { useState } from 'react';
import {
    Modal,
    Paper,
    Typography,
    TextField,
    Button,
    Box
} from '@mui/material';

const DenialReasonModal = ({ open, onClose, onSubmit, event }) => {
    const [reason, setReason] = useState('');

    const handleSubmit = () => {
        if (reason.trim() === '') return;
        onSubmit(reason);
        onClose();
        setReason('');
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Paper
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    maxWidth: '95vw',
                    p: 4,
                    bgcolor: '#202020',
                    color: '#fff',
                    border: '1px solid #333',
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" sx={{ mb: 2, color: '#f44336' }}>
                    Why are you denying this action?
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Please provide a reason so the system can learn and future decisions can improve.
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="E.g. This venue is under construction..."
                    InputProps={{ sx: { color: '#fff' } }}
                    InputLabelProps={{ sx: { color: '#ccc' } }}
                    sx={{ mb: 3 }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button onClick={onClose} variant="outlined">Cancel</Button>
                    <Button onClick={handleSubmit} variant="contained" color="error" disabled={!reason.trim()}>
                        Submit Denial
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};

export default DenialReasonModal;
